import { Button, Input } from '@heroui/react';
import { SearchNormal1 } from 'iconsax-react';

export const SearchBar = ({
  isEditable = true,
  onPress,
  onClear,
  onChange,
  placeholder = 'Искать в zerde',
}: {
  isEditable?: boolean;
  onPress?: () => void;
  onChange?: (value: string) => void;
  onClear?: () => void;
  placeholder?: string;
}) => {
  if (!isEditable) {
    return (
      <div className="py-3 flex-grow">
        <Button
          startContent={<SearchNormal1 size="20" color="#9CA5AC" />}
          disableRipple
          className="bg-[#F5F5F5] text-[#9CA5AC] text-sm justify-start outline-none"
          fullWidth
          size="lg"
          onPress={onPress}
        >
          {placeholder}
        </Button>
      </div>
    );
  }

  return (
    <Input
      isClearable
      onValueChange={onChange}
      onClear={onClear}
      startContent={<SearchNormal1 size="20" color="#9CA5AC" />}
      classNames={{
        innerWrapper: 'h-11',
        inputWrapper: 'lg:h-14',
      }}
    />
  );
};
